import styled from 'styled-components';

export const Button = styled.div`
  align-items: center;
  cursor: default;
  display: flex;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
`;

export const Section = styled.div`
  color: ${({ white }) => (white ? '#fff' : '#333')};
  font-size: 12px;
  padding: 8px 4px;
  position: relative;
  text-transform: uppercase;
  transition: color 0.3s;
`;

export const Highlight = styled.div`
  background-color: #333;
  bottom: 0;
  display: ${({ show }) => (show ? 'block' : 'none')};
  height: 3px;
  left: 0;
  position: absolute;
  width: 100%;
`;

export const SectionWrapper = styled.span`
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/MenuItem.style.js